<template>
    <div class="invoice">
        <Invoice></Invoice>
    </div>
</template>

<script>
    import Invoice from '@/components/invoice_component.vue';

    export default {
        name: 'invoice_view',
        data() {
            return {
            }
        },
        components: {
            Invoice
        }
    }
</script>